
import React from "react";
import { Link } from "react-router-dom";

const FooterQuickLinks = () => {
  return (
    <div className="space-y-4">
      <h3 className="text-base font-semibold">Quick Links</h3>
      <ul className="space-y-2">
        <li>
          <Link to="/" className="text-sm hover:underline">Home</Link>
        </li>
        <li>
          <Link to="/blog" className="text-sm hover:underline">Blog</Link>
        </li>
        <li>
          <Link to="/shop" className="text-sm hover:underline">Shop</Link>
        </li>
        <li>
          <Link to="/quiz" className="text-sm hover:underline">Deodorant Finder Quiz</Link>
        </li>
        <li>
          <Link to="/about" className="text-sm hover:underline">About Us</Link>
        </li>
      </ul>
    </div>
  );
};

export default FooterQuickLinks;
